import {Button, createStyles, Group} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

import {PMEISidepanelDetailData} from './usePMEISidepanelDetail';

const useStyles = createStyles((theme) => ({
  worksheetButtonRow: {
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    borderTop: `1px solid ${theme.colors.gray[2]}`,
    borderBottom: `1px solid ${theme.colors.gray[2]}`,
  },
  worksheetButton: {
    color: theme.white,
    textDecoration: 'none',
    '&:hover, &:visited, &:active, &:focus': {
      color: theme.white,
      textDecoration: 'none',
    },
  },
}));

export default function PMEISidePanelContent({
  detailData,
}: {
  detailData: PMEISidepanelDetailData | null;
}): JSX.Element {
  const {classes} = useStyles();

  return (
    <div {...getTestProps({component: 'PMEISidePanelContent', element: 'root'})}>
      {detailData?.worksheetUrl && (
        <Group position="right" className={classes.worksheetButtonRow}>
          <Button
            component="a"
            href={detailData.worksheetUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="primary"
            size="sm"
            className={classes.worksheetButton}
            {...getTestProps({component: 'PMEISidePanelContent', element: 'openWorksheetButton'})}
          >
            Open Worksheet {detailData.worksheetDisplayId}
          </Button>
        </Group>
      )}
    </div>
  );
}
